module.exports = __webpack_public_path__ + "img/logoIK.294a9038.svg";